export const MIN_USER_NAME_LENGTH = 4;
export const MAX_USER_NAME_LENGTH = 30;

export const LOCAL_STORAGE_TOKEN_KEY = 'spribe_client_token';
export const LOCAL_STORAGE_AUTH_TOKEN_KEY = 'spribe_auth_client_token';
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'spribe_client_refresh_token';
export const LOCAL_STORAGE_EXPIRE_TOKEN_KEY = 'spribe_client_expire_token';

export const SESSION_STORAGE_PROFILE_UPDATE_SUCCESS_KEY = 'profileUpdateSuccess';

export const ACCESS_TOKEN_REFRESH_THRESHOLD_MILLISECONDS = 60000;
